<template>
    <div v-if="!extra.old">
        <span class="timeline-key" v-if="extra && extra.way">Way </span> : {{extra.way.toUpperCase()}} <br>
        <span v-if="extra.purpose_of_visit">  <span class="timeline-key">Purpose of Visit: </span> {{extra.purpose_of_visit}} <br></span>
        <span v-if="extra.desk">  <span class="timeline-key">Desk: </span> {{extra.desk}} <br></span>
        <span v-if="extra.country && extra.country.country_name"><span class="timeline-key">Country arrived From : </span>
            {{extra.country?extra.country.country_name:'n/a'}} <br></span>
        <span v-if="extra.airlines && extra.airlines.airline_name"><span class="timeline-key">Travelled Airline : </span> {{extra.airlines.airline_name}}<br></span>
        <span v-if="extra.airport && extra.airport.name"><span class="timeline-key">Last Airport : </span> {{extra.airport.name}}<br></span>
        <span v-if="extra.image"><span class="timeline-key">Arrival time photo : </span>
            <file-display :src="extra.image"/>
        </span>
        <span v-if="extra.boarding_pass_image"><span class="timeline-key">Boarding pass : </span>
            <file-display :src="extra.boarding_pass_image"/>
        </span>
    </div>
</template>

<script>
    import FileDisplay from "../../FileDisplay";

    export default {
        name: "Arrived",
        props: ['extra', 'days', 'user'],
        components: {FileDisplay},
        mounted() {
            console.log(this.extra);
        }
    }
</script>
